import React from 'react';
import { FadeIn } from './FadeIn';
import { Star } from 'lucide-react';
export function MarcaTestimonials() {
  const testimonials = [{
    quote: 'Empecé con Amazon FBM porque no quería arriesgar mucho dinero. Esta guía me explicó todo paso a paso y ya hice mis primeras ventas desde casa.',
    name: 'Andrea R.',
    location: 'Miami, FL',
    image: 'https://randomuser.me/api/portraits/women/12.jpg'
  }, {
    quote: 'No sabía cómo gestionar pedidos sin bodegas FBA. Aquí aprendí a hacerlo manualmente y ahora controlo todo mi negocio.',
    name: 'Luis C.',
    location: 'Houston, TX',
    image: 'https://randomuser.me/api/portraits/men/32.jpg'
  }, {
    quote: 'Pagaba demasiado en envíos hasta que apliqué los consejos del bono. Hoy ahorro mucho más en cada paquete.',
    name: 'María P.',
    location: 'Los Ángeles, CA',
    image: 'https://randomuser.me/api/portraits/women/29.jpg'
  }, {
    quote: 'Me encantó porque pude empezar con poca inversión. FBM es perfecto para principiantes como yo.',
    name: 'Carlos M.',
    location: 'Orlando, FL',
    image: 'https://randomuser.me/api/portraits/men/45.jpg'
  }, {
    quote: 'Todo está explicado paso a paso. Configuré mi cuenta, publiqué mi primer producto y empecé a vender.',
    name: 'Daniela G.',
    location: 'Chicago, IL',
    image: 'https://randomuser.me/api/portraits/women/40.jpg'
  }, {
    quote: 'Lo mejor es que no necesité enviar inventario a Amazon. Trabajo desde casa con mi propio stock y eso me da más control.',
    name: 'José T.',
    location: 'Dallas, TX',
    image: 'https://randomuser.me/api/portraits/men/22.jpg'
  }, {
    quote: 'El módulo de campañas publicitarias me ayudó muchísimo. Ahora mis productos aparecen primero y tengo más ventas.',
    name: 'Sofía L.',
    location: 'New York, NY',
    image: 'https://randomuser.me/api/portraits/women/55.jpg'
  }, {
    quote: 'No es solo teoría, son pasos reales. Logré encontrar productos rentables y empezar mi tienda en Amazon FBM.',
    name: 'Miguel A.',
    location: 'Phoenix, AZ',
    image: 'https://randomuser.me/api/portraits/men/56.jpg'
  }, {
    quote: 'La parte de proveedores fue clave. Encontré productos buenos a buen precio y empecé con bases sólidas.',
    name: 'Valentina S.',
    location: 'San Diego, CA',
    image: 'https://randomuser.me/api/portraits/women/63.jpg'
  }, {
    quote: 'FBM me dio la libertad de empezar sin grandes costos. Es la mejor opción si recién comienzas.',
    name: 'Fernando D.',
    location: 'Atlanta, GA',
    image: 'https://randomuser.me/api/portraits/men/64.jpg'
  }, {
    quote: 'Aprendí a publicar productos correctamente y eso cambió todo. Mis listings ahora se ven profesionales.',
    name: 'Paola V.',
    location: 'Las Vegas, NV',
    image: 'https://randomuser.me/api/portraits/women/76.jpg'
  }, {
    quote: 'Pasé de no saber nada a tener mi tienda funcionando. Esta guía es clara, práctica y vale totalmente la pena.',
    name: 'Ricardo H.',
    location: 'Charlotte, NC',
    image: 'https://randomuser.me/api/portraits/men/78.jpg'
  }];
  return <section className="bg-brand-beige py-24 px-6" data-id="element-386">
      <div className="max-w-7xl mx-auto" data-id="element-387">
        <FadeIn data-id="element-388">
          <div className="text-center mb-16" data-id="element-389">
            <span className="text-4xl mb-4 block" data-id="element-390">🚀</span>
            <h2 className="text-3xl md:text-4xl font-bold text-brand-green uppercase tracking-wide mb-4" data-id="element-391">
              RESULTADOS REALES VENDIENDO EN AMAZON FBM
            </h2>
            <p className="text-lg md:text-xl text-brand-text/70 max-w-3xl mx-auto" data-id="element-392">
              Personas que empezaron desde cero y hoy generan ingresos con
              Amazon FBM
            </p>
          </div>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-393">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={0.05 * (index % 6)} data-id="element-394">
              <div className="bg-white p-8 rounded-2xl h-full flex flex-col border border-brand-beige hover:border-brand-gold/30 transition-colors shadow-sm" data-id="element-395">
                <div className="flex gap-1 mb-4" data-id="element-396">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-brand-gold text-brand-gold" data-id="element-397" />)}
                </div>
                <p className="text-brand-text/90 italic mb-6 flex-grow leading-relaxed" data-id="element-398">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-3" data-id="element-399">
                  <img src={testimonial.image} alt={testimonial.name} className="w-11 h-11 rounded-full object-cover border-2 border-brand-beige" data-id="element-400" />
                  <div data-id="element-401">
                    <p className="font-semibold text-brand-green leading-tight" data-id="element-402">
                      {testimonial.name}
                    </p>
                    <p className="text-xs text-brand-text/50" data-id="element-403">
                      {testimonial.location}
                    </p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}